<template>
	<div class="header-submenu">
		<div class="header-submenu__need-to-know">
			<p class="header-submenu__title">Guides by Topic</p>
			<div class="header-submenu__items">
				<a
					:href="needToKnowItem.url"
					:class="`header-submenu__item--${needToKnowItem.slug}`"
					v-for="needToKnowItem in needToKnowItems"
				>
					<div class="header-submenu__item" @click="$emit('close-menu')">
						<img :src="needToKnowItem.icon" />
						<div class="header-submenu__link">{{ needToKnowItem.name }}</div>
					</div>
				</a>
			</div>

			<p class="header-submenu__title">Guides by Industries</p>
			<div class="by-industries header-submenu__items">
				<a
					:href="industriesItems.url"
					:class="`header-submenu__item--${industriesItems.slug}`"
					v-for="industriesItems in industriesItems"
				>
					<div class="header-submenu__item" @click="$emit('close-menu')">
						<img :src="industriesItems.icon" />
						<div class="header-submenu__link">{{ industriesItems.name }}</div>
					</div>
				</a>
			</div>
		</div>
		<div class="header-submenu__more">
			<p class="header-submenu__title">Business Resources</p>
			<ATInAction :customItems="moreItems" />

			<p class="header-submenu__title">Quizes</p>
			<ATInAction :customItems="quizeItems" />
			<div class="header-submenu__item-icon header-submenu__item-icon--right">
				<link-arrow text="See all guides and resources" href="/blog" />
			</div>
		</div>
	</div>
</template>

<script>
import LinkArrow from '../partials/LinkArrow.vue';
import ATInAction from '../header/ATInAction.vue';

export default {
	data() {
		return {
			needToKnowItems: [
				{
					slug: 'time-tracking',
					name: 'Time Tracking',
					url: '/time-tracking',
					icon: '/dist/img/header/resources/tracking.svg',
				},
				{
					slug: 'project-cost-management',
					name: 'Project Costs',
					url: '/project-cost-management',
					icon: '/dist/img/header/resources/project.svg',
				},
				{
					slug: 'manage-remote-team',
					name: 'Remote Work',
					url: '/remote-work-guide',
					icon: '/dist/img/header/resources/remote.svg',
				},
				{
					slug: 'overtime-guide',
					name: 'Overtime',
					url: '/overtime-guide',
					icon: '/dist/img/header/resources/overtime.svg',
				},
				{
					slug: 'project-time-estimation',
					name: 'Time Estimation',
					url: '/project-time-estimation',
					icon: '/dist/img/header/resources/estimation.svg',
				},
				{
					slug: 'software-collections',
					name: 'Software Collections',
					url: '/software-collections',
					icon: '/dist/img/header/resources/software.svg',
				},
				{
					slug: 'time-management-guide',
					name: 'Time Management',
					url: '/time-management-guide',
					icon: '/dist/img/header/resources/time.svg',
				},
				{
					slug: 'productivity',
					name: 'Productivity',
					url: '/productivity',
					icon: '/dist/img/header/resources/productivity.svg',
				},
				{
					slug: 'human-resources',
					name: 'People Management',
					url: '/human-resources',
					icon: '/dist/img/header/resources/people.svg',
				},
			],

			industriesItems: [
				{
					slug: 'developers-time-tracking',
					name: 'For Developers',
					url: '/developers-time-tracking',
					icon: '/dist/img/header/resources/book.svg',
				},
				{
					slug: 'software-for-architects',
					name: 'For Architects',
					url: '/software-for-architects',
					icon: '/dist/img/header/resources/building.svg',
				},
				{
					slug: 'agency-time-tracking',
					name: 'For Marketers',
					url: '/agency-time-tracking',
					icon: '/dist/img/header/resources/favorite-chart.svg',
				},
				{
					slug: 'school-management-software',
					name: 'For Schools',
					url: '/school-management-software',
					icon: '/dist/img/header/resources/teacher.svg',
				},
				{
					slug: 'ecommerce-software',
					name: 'For E-commerce',
					url: '/ecommerce-software',
					icon: '/dist/img/header/resources/bag-tick.svg',
				},
			],

			moreItems: [
				{
					class: 'header-submenu__item--custom-items',
					name: 'E-Book',
					url: '/ebook/how-to-choose-right-time-tracker',
					icon: '/dist/img/header/business-tools/ebook.svg',
				},
				{
					class: 'header-submenu__item--custom-items',
					name: 'Business Templates',
					url: '/templates',
					icon: '/dist/img/header/business-tools/business.svg',
				},
				{
					class: 'header-submenu__item--custom-items',
					name: 'Overtime Calculator',
					url: '/overtime-calculator',
					icon: '/dist/img/header/business-tools/calculator.svg',
				},
				{
					class: 'header-submenu__item--custom-items',
					name: "Time Trackers' List",
					url: '/timesheet-software-list',
					icon: '/dist/img/header/business-tools/time.svg',
				},
			],

			quizeItems: [
				{
					class: 'header-submenu__item--custom-items',
					name: 'Project Management',
					url: '/project-management/project-management-skills-quiz',
					icon: '/dist/img/header/resources/task-square.svg',
				},
				{
					class: 'header-submenu__item--custom-items',
					name: 'Time Management',
					url: '/quiz-time-management',
					icon: '/dist/img/header/resources/timer-start.svg',
				},
			],
		};
	},


	components: {
		ATInAction,
		LinkArrow,
	},
};
</script>

<style lang="scss">
@import '../../../../scss/layout/header/header-submenu.scss';

.header-submenu__need-to-know .by-industries .header-submenu__item--overtime-guide:hover div {
	background: #F2F6FF;
}
</style>



// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/header/Resources.vue